import { defineStore } from "pinia";

export const useDebugStore = defineStore("debug", {
    state: () => ({
        debugMode: false,
    }),
});
